import { NumberInput, NumberInputProps } from 'react-admin';

export const QuickbooksPriceInput = (props: NumberInputProps) => (
  <NumberInput {...props} />
);
